import React, { Component, Suspense, lazy } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { FLOOR, ROOM } from '../../reduxs'
import {
  LIST_ROOM,
  FILTER_DEFAULT,
  SPACE_STATUS,
  ROOM_STATUS,
  MAX_ROOM_LIST_LIMIT,
  TAB_KEY,
  CAPACITY_OPTIONS,
  STATUS_OPTIONS,
  getLocaleDateStringFull,
  checkPermission,
  ROUTE,
  PERMISSION_PAGE
} from '../../helpers'
import { StyleListFloor } from './style'
import { Loader, Topbar, FilterSelect, SpaceTypeFilter } from '../../components'

import ReactGA from "react-ga"
import { IMG, COLOR, FONT_SIZE, getFontContrastColor } from '../../themes'

const ListRoom = lazy(() => import('./ListRoom'))

export class ListFloor extends Component {
  constructor(props) {
    super(props)
    this.state = {
      limit: 1000,
      activeTab: TAB_KEY.ALL_SPACES, 
      selectedBuildingId: null,
      search: '',
      spaceType: FILTER_DEFAULT,
      capacity: FILTER_DEFAULT,
      spaceStatus: FILTER_DEFAULT,
      rooms: [],
      favoriteCount: 0,
      isLoading: true,
      isBuildingDropdownOpen: false
    }

    //GA TrackingId
    ReactGA.initialize("UA-153387162-1")
    ReactGA.pageview("Meeting Spaces Page")
  }

  componentDidMount() {
    this.props.floorAction.getListFloor({
      companyId: this.props.accountReducer.user.companyId,
      limit: this.state.limit,
      sorts: JSON.stringify([{ type: "ASC", column: "companyName" }, { type: "ASC", column: "buildingName" }, { type: "ASC", column: "floorLevel" }]),
      status: ROOM_STATUS.ACTIVE
    })
    this.fetchFavoriteCount()
  }

  componentDidUpdate(prevProps, prevState) {
    const { displayDate, floorReducer } = this.props
    const { listFloor } = floorReducer
    const prevListFloor = prevProps.floorReducer.listFloor

    if (prevProps.displayDate.toString() !== displayDate.toString()) {
      this.props.floorAction.clearListFloor()
      this.componentDidMount()
    }

    if (listFloor && listFloor !== prevListFloor && listFloor.length > 0 && !this.state.selectedBuildingId) {
      const uniqueBuildings = _.uniqBy(listFloor, 'buildingId')
      if (uniqueBuildings.length > 0) {
        this.setState({ selectedBuildingId: uniqueBuildings[0].buildingId }, this.fetchRooms)
      }
    }

    if (
      prevState.activeTab !== this.state.activeTab ||
      prevState.selectedBuildingId !== this.state.selectedBuildingId ||
      prevState.spaceType !== this.state.spaceType ||
      prevState.spaceStatus !== this.state.spaceStatus
    ) {
      if (prevState.activeTab !== this.state.activeTab || prevState.selectedBuildingId !== this.state.selectedBuildingId) {
        this.fetchRooms()
      }
    }
  }

  getBaseRoomParams = () => {
    const { accountReducer } = this.props

    return {
      companyId: accountReducer.user.companyId,
      status: ROOM_STATUS.ACTIVE,
      buildingId: this.state.selectedBuildingId,
      spaceType: ['room', 'desk', 'other'],
    }
  }

  fetchFavoriteCount = () => {
    if (!this.state.selectedBuildingId) return

    const param = {
      ...this.getBaseRoomParams(),
      limit: 1,
      isFavourite: true
    }
    this.props.roomAction.getRoomsV2(param, (data) => {
      const count = data.count !== undefined ? data.count : (data.list ? data.list.length : 0)
      this.setState({ favoriteCount: count })
    })
  }

  fetchRooms = (silent = false) => {
    const { roomAction } = this.props
    const { activeTab, selectedBuildingId, search, spaceType, capacity, spaceStatus } = this.state

    if (!selectedBuildingId) return

    if (silent !== true) {
      this.setState({ isLoading: true })
    }

    const param = {
      ...this.getBaseRoomParams(),
      limit: MAX_ROOM_LIST_LIMIT,
    }

    if (activeTab === TAB_KEY.MY_FAVORITE) {
      param.isFavourite = true
    }

    if (search) {
      param.roomName = search
    }

    if (spaceType !== FILTER_DEFAULT) {
      param.spaceType = spaceType
    }

    if (spaceStatus !== FILTER_DEFAULT) {
      param.isUsing = spaceStatus === SPACE_STATUS.AVAILABLE ? SPACE_STATUS.IS_USING.AVAILABLE : SPACE_STATUS.IS_USING.BUSY
    }

    if (capacity !== FILTER_DEFAULT) {
      const [min, max] = capacity.split('-')
      param.minCapacity = parseInt(min, 10)
      param.maxCapacity = parseInt(max, 10)
    }

    roomAction.getRoomsV2(param, (data) => {
      this.setState({ rooms: data.list || [], isLoading: false })
      this.fetchFavoriteCount()
    })
  }

  debouncedFetchRooms = _.debounce(() => {
    this.fetchRooms()
  }, 1000)

  handleSearch = (e) => {
    if (e.key === 'Enter') {
      this.debouncedFetchRooms.cancel()
      this.fetchRooms()
    }
  }

  renderFilters = () => {
    const { search, spaceType, capacity, spaceStatus } = this.state
    const { language } = this.props.accountReducer
    const colorTheme = this.props.settingReducer?.settingTheme?.colorTheme
    const hasFilter = search !== '' || spaceType !== FILTER_DEFAULT || capacity !== FILTER_DEFAULT || spaceStatus !== FILTER_DEFAULT

    return (
      <div className="filter-bar">
        <div className="filter-row">
          <div className="filter-input-container search">
            <input 
              type="text" 
              className="filter-input" 
              placeholder={LIST_ROOM.SEARCH_SPACES[language]}
              value={search}
              onChange={(e) => {
                this.setState({ search: e.target.value })
                this.debouncedFetchRooms()
              }}
              onKeyDown={this.handleSearch}
            />
            <img src={IMG['ic_search-input.svg']} alt="search" className="filter-icon-right" />
          </div>
        </div>
        <div className="filter-row">
          <div className="filter-input-container">
            <SpaceTypeFilter
              value={spaceType}
              onChange={(val) => this.setState({ spaceType: val }, this.fetchRooms)}
              language={language}
              colorTheme={colorTheme}
            />
          </div>

          <div className="filter-input-container">
            <FilterSelect
              value={capacity}
              options={CAPACITY_OPTIONS}
              placeholder={LIST_ROOM.CAPACITY[language]}
              onChange={(val) => this.setState({ capacity: val }, this.fetchRooms)}
              language={language}
              colorTheme={colorTheme}
            />
          </div>

          <div className="filter-input-container">
            <FilterSelect
              value={spaceStatus}
              options={STATUS_OPTIONS}
              placeholder={LIST_ROOM.SPACE_STATUS[language]}
              onChange={(val) => this.setState({ spaceStatus: val }, this.fetchRooms)}
              language={language}
              colorTheme={colorTheme}
            />
          </div>

          <button 
            className="clear-filter-btn"
            onClick={() => {
              if (hasFilter) {
                this.setState({ search: '', spaceType: FILTER_DEFAULT, capacity: FILTER_DEFAULT, spaceStatus: FILTER_DEFAULT }, this.fetchRooms)
              }
            }}
          >
            {LIST_ROOM.CLEAR_FILTER[language]}
            <img src={IMG['ic_clear-filter.svg']} alt="clear" className="filter-icon-right" style={{ marginLeft: '4px' }} />
          </button>
        </div>
      </div>
    )
  }

  renderContent() {
    const {
      floorReducer: { listFloor },
      accountReducer: { user, language },
      settingReducer,
    } = this.props
    const { colorTheme } = settingReducer.settingTheme
    const { activeTab, selectedBuildingId, rooms, isLoading, spaceStatus, capacity } = this.state

    if (!listFloor || isLoading && rooms.length === 0) {
      return <Loader colorTheme={colorTheme} />
    }

    if (listFloor.length === 0) {
      return <div className='notFound'>{LIST_ROOM.NOT_LIST[language]}</div>
    }

    const uniqueBuildings = _.uniqBy(listFloor, 'buildingId')
    const selectedBuilding = uniqueBuildings.find(b => b.buildingId === selectedBuildingId)

    const roomsByFloor = _.groupBy(rooms, r => r.floor.floorLevel)
    const sortedFloors = Object.keys(roomsByFloor).sort((a, b) => parseInt(a) - parseInt(b))

    return (
      <div className='content'>
        <div className="tabs-container">
          <div 
            className={`tab-item ${activeTab === TAB_KEY.ALL_SPACES ? 'tab-active' : 'tab-inactive'}`}
            onClick={() => this.setState({ activeTab: TAB_KEY.ALL_SPACES })}
          >
            {LIST_ROOM.ALL_SPACES[language]}
          </div>
          <div 
            className={`tab-item ${activeTab === TAB_KEY.MY_FAVORITE ? 'tab-active' : 'tab-inactive'}`}
            onClick={() => this.setState({ activeTab: TAB_KEY.MY_FAVORITE })}
          >
            {LIST_ROOM.MY_FAVORITE[language]} ({this.state.favoriteCount || 0})
          </div>
        </div>

        <div className="building-header building-header-wrapper">
          <div 
            className="building-trigger"
            onClick={() => this.setState(prev => ({ isBuildingDropdownOpen: !prev.isBuildingDropdownOpen }))}
          >
            <span className="building-title">{selectedBuilding?.buildingName || 'Select Building'}</span>
            <img 
              src={IMG['ic_expand-more.svg']} 
              alt="expand" 
              className="custom-select-icon"
              style={{ 
                transform: this.state.isBuildingDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)' 
              }} 
            />
          </div>
          
          {this.state.isBuildingDropdownOpen && (
            <>
              <div 
                className="dropdown-overlay"
                onClick={() => this.setState({ isBuildingDropdownOpen: false })} 
              />
              <div className="building-dropdown">
                {uniqueBuildings.map(b => {
                  const isSelected = b.buildingId === selectedBuildingId;
                  const colorTheme = this.props.settingReducer?.settingTheme?.colorTheme || COLOR.GOLD_1;
                  const contrastColor = getFontContrastColor(colorTheme);
                  return (
                    <div 
                      key={b.buildingId}
                      className="dropdown-option building-option"
                      style={{
                        color: isSelected ? contrastColor : COLOR.BLACK_5,
                        backgroundColor: isSelected ? colorTheme : 'transparent',
                      }}
                      onClick={() => this.setState({ selectedBuildingId: b.buildingId, isBuildingDropdownOpen: false })}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = colorTheme;
                          e.currentTarget.style.color = contrastColor;
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.color = COLOR.BLACK_5;
                        }
                      }}
                    >
                      {b.buildingName}
                    </div>
                  )
                })}
              </div>
            </>
          )}
        </div>

        {this.renderFilters()}

        {isLoading ? (
          <Loader colorTheme={colorTheme} />
        ) : rooms.length === 0 ? (
          <div className='notFound'>
            {activeTab === TAB_KEY.MY_FAVORITE ? LIST_ROOM.NO_BOOKMARK[language] : LIST_ROOM.NO_ROOM[language]}
          </div>
        ) : (
          <Suspense fallback={<Loader colorTheme={colorTheme} />}>
            <ListRoom 
              {...this.props} 
              roomsByFloor={roomsByFloor} 
              sortedFloors={sortedFloors} 
              onRefresh={this.fetchRooms}
            />
          </Suspense>
        )}
      </div>
    )
  }

  render () {
    const { displayDate, accountReducer, settingReducer } = this.props
    const { colorTheme } = settingReducer.settingTheme || {}
    return (
      <StyleListFloor colorTheme={colorTheme}>
        <Topbar
          textBreadcrumbStart={LIST_ROOM.NAME[accountReducer.language]}
          textCenter={getLocaleDateStringFull(displayDate, accountReducer.language)}
        />
        {checkPermission(accountReducer.permission, ROUTE.MEETING_ROOM.CODE)
          ? this.renderContent()
          : <div className='content'>{PERMISSION_PAGE.NOT_FOUND[accountReducer.language]}</div>
        }
      </StyleListFloor>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    floorAction: bindActionCreators(FLOOR.action, dispatch),
    roomAction: bindActionCreators(ROOM.action, dispatch),
  }
}

const mapStateToProps = ({ accountReducer, loaderReducer, floorReducer, settingReducer }) => {
  return {
    accountReducer,
    floorReducer,
    loaderReducer,
    settingReducer,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ListFloor)

